import React from 'react';
import styles from './OfferPage.module.css';

interface OfferBulletListProps {
	items: string[];
}

export function OfferBulletList({items}: OfferBulletListProps): React.ReactElement {
	return (
		<ul className={styles.bulletList}>
			{items.map((item) => (
				<li key={item} className={styles.bulletItem}>
					<span className={styles.bullet} aria-hidden />
					<span>{item}</span>
				</li>
			))}
		</ul>
	);
}
